import { useState, useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { getBackgroundImage, isMobilePortraitView, getRaceGradient } from '../utils/background';

export function useBackground() {
    const { profile } = useAuthStore();
    const [isMobilePortrait, setIsMobilePortrait] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState<string>('');

    useEffect(() => {
        const checkMobilePortrait = () => {
            const mobile = isMobilePortraitView();
            setIsMobilePortrait(mobile);
            setBackgroundImage(getBackgroundImage(profile?.race, mobile));
        };

        // Initial check
        checkMobilePortrait();

        // Listen for resize events
        window.addEventListener('resize', checkMobilePortrait);

        return () => {
            window.removeEventListener('resize', checkMobilePortrait);
        };
    }, [profile?.race]);

    const gradient = getRaceGradient(profile?.race);

    return {
        backgroundImage,
        isMobilePortrait,
        gradient,
        race: profile?.race,
    };
}